import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { createPortal } from 'react-dom';

import classes from './ProductSidebars.scss';

type Props = {
    isMob: boolean;
};

export const ProductSidebars: React.FC<React.PropsWithChildren<Props>> = ({ isMob, children }) => {
    const [element, setElement] = useState<HTMLElement | null>(null);

    useEffect(() => {
        setElement(document.getElementById('ProductDetailSidebarPortal'));
    }, []);

    if (isMob && element)
        return createPortal(<div className={classnames(classes.container, classes.mobile)}>{children}</div>, element);

    return <div className={classnames(classes.container)}>{children}</div>;
};
